<template>
    <div class="hero tc">
        <h1 class="fw4 f3 lh-solid mb0 mt5">{{ cityName }}</h1>
        <p class="fw3 f6 lh-solid mv2">{{ weatherMood }}</p>
        <h2 class="fw3 f-subheadline lh-solid mv0 indent-small">{{ temperature }}</h2>
    </div>
</template>

<script>
export default {
    name: 'Hero',
    props: {
        cityName: String,
        weatherMood: String,
        temperature: String,
    },
};
</script>

<style lang="scss">

</style>
